import axios from 'axios'

const apiClient = axios.create({
  baseURL: `${window.SimplyFlightsFrontend.restUrl}simply-flights/v1`,
  headers: {
    'Content-Type': 'application/json',
    'X-Simply-Core-Token': window.SimplyFlightsFrontend.token
  }
})

export default {

  // READ - SCHEDULES
  readSchedules() {
    return apiClient.get( '/schedules' )
  },

  // READ - SLOTS
  readSlots( { origin, destination, date, passengersCount } ) {
    return apiClient.get('/slots', {
      params: {
        origin,
        destination,
        date,
        passengersCount
      }
    })
  },

  // CREATE - RESERVATION
  createReservation( reservation ) {
    return apiClient.post( '/reservations', reservation )
  },

  // CANCEL - RESERVATION
  cancelReservation( payload ) {
    return apiClient.post( '/reservations/cancel', payload )
  }
}